import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { toursEmptyPage } from 'shared/constants/tours'
import ImageBag from 'shared/images/bag.svg'
import { openWhatsappWithMessage } from 'shared/lib/openWhatsappWithMessage'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

export const EmptyResults = () => {
  const { t } = useTranslation()

  const handleOpenWhatsapp = () => {
    openWhatsappWithMessage(toursEmptyPage)
  }

  return (
    <div className={clsx(s.emptyResults, 'container')}>
      <div className={s.emptyResultsContent}>
        <div className={s.image}>
          <ImageLazy
            src={ImageBag}
            alt="bag image"
          />
        </div>

        <div className={clsx(s.title, 'bold-22')}>
          {t('tours_block.didnt_find_tour')}
        </div>
        <div className={clsx(s.subTitle, 'medium-14')}>
          {t('tours_block.not_found_description')}
        </div>

        <Button
          className={clsx('semi-bold-17', s.button)}
          onClick={handleOpenWhatsapp}
        >
          <AppIcon id={AllIcons.WHATSAPP_ICON} />

          {t('tours_block.write_whatsapp')}
        </Button>
      </div>
    </div>
  )
}
